import React, { useState, useEffect, useCallback } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  MdDashboard,
  MdNoteAlt,
  MdAssignment,
  MdAccountBalanceWallet,
  MdSupport,
} from "react-icons/md";
import { FaBell, FaCog } from "react-icons/fa";
import { IoBookSharp } from "react-icons/io5";
import { LogOut } from "lucide-react";

import "../../../assests/css/studentdashboard/StudentSidebar.css";
import { Robot } from "react-bootstrap-icons";

const navLinks = [
  { to: "/student/dashboard", icon: <MdDashboard />, label: "Dashboard" },
  { to: "/student/notes", icon: <MdNoteAlt />, label: "Notes" },
  { to: "/student/exam", icon: <MdAssignment />, label: "Exams" },
  { to: "/fee/management", icon: <MdAccountBalanceWallet />, label: "Fee Management" },
  { to: "/student/notification", icon: <FaBell />, label: "Notifications" },
  { to: "/student/setting", icon: <FaCog />, label: "Settings" },
  { to: "/help/support", icon: <MdSupport />, label: "Help & Support" },
  { to: "/student/career", icon: <Robot />, label: "Student Career consultanat" },

];

const StudentSidebar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const closeSidebar = useCallback(() => setOpen(false), []);
  const toggleSidebar = useCallback(() => setOpen((prev) => !prev), []);

  /* Close on route change */
  useEffect(() => { closeSidebar(); }, [location.pathname, closeSidebar]);

  /* Lock body scroll when sidebar is open on mobile */
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  /* Close on Escape key */
  useEffect(() => {
    const handleKey = (e) => { if (e.key === "Escape") closeSidebar(); };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [closeSidebar]);

  /* Close when viewport becomes desktop */
  useEffect(() => {
    const onResize = () => { if (window.innerWidth > 768) closeSidebar(); };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [closeSidebar]);

  return (
    <>
      {/* ===== MOBILE TOP BAR ===== */}
      <header className="std-mobile-bar" role="banner">
        <div className="std-mobile-bar__left">
          <button
            className="std-mobile-btn"
            onClick={toggleSidebar}
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            aria-controls="std-sidebar"
          >
            {open ? "✕" : "☰"}
          </button>
          <div className="std-mobile-title">
            <IoBookSharp aria-hidden="true" />
            <span>College Portal</span>
          </div>
        </div>

        {/* Right side avatar */}
        <div className="std-mobile-bar__right">
          <div className="std-mobile-avatar" aria-label="Student">
            <span>S</span>
          </div>
        </div>
      </header>

      {/* ===== OVERLAY ===== */}
      {open && (
        <button
          className="std-overlay"
          onClick={closeSidebar}
          aria-label="Close menu"
          tabIndex={-1}
        />
      )}

      {/* ===== SIDEBAR ===== */}
      <aside
        id="std-sidebar"
        className={`std-sidebar${open ? " std-open" : ""}`}
        aria-label="Student navigation"
      >
        {/* Header */}
        <div className="std-sidebar-header">
          <IoBookSharp className="std-logo-icon" aria-hidden="true" />
          <h2>GGCW Student</h2>

          {/* Mobile close inside sidebar */}
          <button
            className="std-sidebar-close"
            onClick={closeSidebar}
            aria-label="Close sidebar"
          >
            ✕
          </button>
        </div>


        <ul className="std-menu">

          <li>
            <NavLink
              to="/student/dashboard"
              className="std-menu-link"
              onClick={closeSidebar}
            >
              <MdDashboard />
              <span>Dashboard</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/fee/management"
              className="std-menu-link"
              onClick={closeSidebar}
            >
              <MdAccountBalanceWallet />
              <span>Fee </span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/student/notes"
              className="std-menu-link"
              onClick={closeSidebar}
            >
              <MdNoteAlt />
              <span>Notes</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/student/myrequest"
              className="std-menu-link"
              onClick={closeSidebar}
            >
              <MdDashboard />
              <span>MyRequest</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/student/exam"
              className="std-menu-link"
              onClick={closeSidebar}
            >
              <MdAssignment />
              <span>Exams</span>
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/help/support"
              className="std-menu-link"
              onClick={closeSidebar}
            >
              <MdSupport />
              <span>Help & Support</span>
            </NavLink>
          </li>



          <li>
            <NavLink
              to="/student/notification"
              className="std-menu-link"
              onClick={closeSidebar}
            >
              <FaBell />
              <span>Notification</span>
            </NavLink>
          </li>

             <li>
            <NavLink
              to="/student/career"
              className="std-menu-link"
              onClick={closeSidebar}
            >
              <Robot />
              <span>Student Career consultanat</span>
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/student/setting"
              className="std-menu-link"
              onClick={closeSidebar}
            >
              <FaCog />
              <span>Settings</span>
            </NavLink>
          </li>



        </ul>
        <NavLink
          to="/student/logout"
          className="ts-logout"
          onClick={closeSidebar}
        >
          <LogOut size={18} />
          <span>Logout</span>
        </NavLink>

      </aside>
    </>
  );
};

export default StudentSidebar;